(() => {
    class CampaignFaq {
        constructor(root) {
            this.root = root;
            this.items = [...root.querySelectorAll('.faq-item')];
            if (!this.items.length) return;
            this.bind();
            this.items.forEach(item => {
                if (item.classList.contains('is-open')) this.open(item, false);
            });
        }
        bind() {
            this.items.forEach(item => {
                const button = item.querySelector('.faq-item__header');
                button.addEventListener('click', () => {
                    if (item.classList.contains('is-open')) {
                        this.close(item);
                        return;
                    }
                    this.items.forEach(other => { if (other !== item) this.close(other); });
                    this.open(item);
                });
            });
            window.addEventListener('resize', () => {
                this.items.forEach(item => {
                    if (item.classList.contains('is-open')) this.setHeight(item);
                });
            });
        }
        setHeight(item) {
            const content = item.querySelector('.faq-item__content');
            const inner = item.querySelector('.faq-item__inner');
            content.style.setProperty('--content-height', `${inner.scrollHeight}px`);
        }
        open(item, animate = true) {
            const content = item.querySelector('.faq-item__content');
            this.setHeight(item);
            if (!animate) {
                content.style.transition = 'none';
                requestAnimationFrame(() => { content.style.transition = ''; });
            }
            item.classList.add('is-open');
        }
        close(item) {
            item.classList.remove('is-open');
        }
    }
    document.querySelectorAll('[data-campaign-faq]').forEach(section => new CampaignFaq(section));
})();
